import { useState } from "react";
import { FaTimes, FaHandshake } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
// Ensure this path exists or replace with your logout logic
import { onErrorLogout } from "../_config/authService";

import logo from "../assets/logo.jpeg";
import dashboard from "../assets/icons/dashboard.svg";
import HomeService from "../assets/icons/HomeService.svg";
import Cities from "../assets/icons/cities.svg";
import profile from "../assets/icons/profile.svg";
import security from "../assets/icons/security.svg";
import contact from "../assets/icons/contact-us.png";
import users from "../assets/icons/users.svg";
import property from "../assets/icons/property.svg";
import bank from "../assets/icons/bank.svg";
import logout from "../assets/icons/logout.svg";
import { BsImages } from "react-icons/bs";
import { 
  FiBriefcase,   // Career Management ke liye
  FiUserCheck,   // Admin Management ke liye
  FiImage,       // Add Banners ke liye
  FiUsers,       // Users Management ke liye
  FiMapPin,      // City Management ke liye
  FiCreditCard   // Payment History ke liye
} from "react-icons/fi";



// 1. CONFIG: Defines which pages belong to which role generally
const ROLE_PAGE_ACCESS = {
  property_team: ["pending", "approved", "sold", "rejected", "queries", "categories"],
  services_team: ["service_booking", "category_management", "queries"],
  loan_team: ["loan_management", "queries"],
  support_team: ["queries"],
};

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  // 2. GET USER DATA
  const currentAdmin = JSON.parse(sessionStorage.getItem("user")) || {};
  const userRole = currentAdmin?.role;
  const isAdmin = userRole === "admin";
  const isTeamLeader = currentAdmin?.leader === true;
  const userPages = currentAdmin?.accessPages || [];

  /* ===== MENU ITEMS ===== */
const propertyMenu = [
    { name: "pending", label: "+ Add Property", to: "/properties/add" },
    { name: "pending", label: "Pending", to: "/properties/pending" },
    { name: "approved", label: "Approved", to: "/properties/approved" },
    { name: "sold", label: "Sold", to: "/properties/sold" },
    { name: "rejected", label: "Rejected", to: "/properties/rejected" },
    { name: "rejected", label: "Disabled", to: "/properties/inactive" },
    { name: "queries", label: "Queries", to: "/properties/query" },
    { name: "categories", label: "Property Categories", to: "/properties/categories" },
  ];

  const loanMenu = [
    { name: "loan_management", label: "All Loans", to: "/loans/listing" },
    { name: "loan_management", label: "Create Loans", to: "/loans/add-new" },
    { name: "queries", label: "Loan Queries", to: "/loans/queries" },
  ];

  const servicesMenu = [
    {
      name: "category_management",
      label: "Service Categories",
      to: "/services/category",
    },
    {
      name: "category_management",
      label: "Create Service Category",
      to: "/services/create",
    },
    {
      name: "service_booking",
      label: "Service Bookings",
      to: "/services/booking",
    },
    { name: "queries", label: "Agent Job Queries", to: "/services/Ajent" },
    { name: "queries", label: "Approved Agents", to: "/services/my-agents" },
    { name: "payouts", label: "COD Settlements", to: "/services/agent-settlements" }, 
    { name: "category_management", label: "Subscription Plans", to: "/services/subscription" },
    { name: "payouts", label: "Agent Withdrawals", to: "/services/withdrawal-requests" },

  ];

  /* ===== 🔐 PERMISSION LOGIC (Strict) ===== */

  // Check individual page access
  const canAccessPage = (pageName) => {
    if (isAdmin) return true;
    if (!userRole || !ROLE_PAGE_ACCESS[userRole]) return false;

    const roleAllowedPages = ROLE_PAGE_ACCESS[userRole];

    // Check 1: Does this page belong to this Role?
    if (!roleAllowedPages.includes(pageName)) {
      return false;
    }

    // Check 2: Leader (All access within role) vs Member (Specific access)
    if (isTeamLeader) return true;
    return userPages.includes(pageName);
  };

  // Check Section Access (e.g., Hide Loans entirely for Property Team)
  const isSectionAllowed = (targetRole) => {
    if (isAdmin) return true;
    return userRole === targetRole;
  };

  /* ===== UI ===== */
  return (
    <>
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/40 z-30 lg:hidden"
        />
      )}

      <div
        className={`fixed top-0 left-0 h-full w-64
        bg-[#24ADD7]/90 text-white 
        dark:bg-[#222C3E] dark:text-white 
        flex flex-col transition-all duration-500 z-40 shadow-xl
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* LOGO */}
        <div className="relative py-4 bg-white dark:bg-[#1E293B] border-b border-gray-200 dark:border-white/10 flex justify-center items-center gap-2">
          <img src={logo} alt="logo" className="h-10 w-10 object-contain rounded-full shadow-sm" />
          <span className="text-2xl font-bold tracking-wide">
            <span className="text-[#24ADD7]">Property</span>
            <span className="text-[#596475] dark:text-gray-300">Le</span>
          </span>

          {/* Close Btn Mobile */}
          <button
            className="lg:hidden p-2 rounded-md hover:bg-black/10 dark:hover:bg-white/10 absolute right-4 top-1/2 -translate-y-1/2"
            onClick={() => setSidebarOpen(false)}
          >
            <FaTimes className="text-gray-800 dark:text-white" />
          </button>
        </div>

        {/* SCROLL AREA START */}
        <div className="flex-1 overflow-y-auto custom-scrollbar">
          {isAdmin && (
            <div className="mt-4">
              <MenuItem
                to="/"
                img={dashboard}
                label="Dashboard"
                setSidebarOpen={setSidebarOpen}
              />
            </div>
          )}

          {/* PROPERTIES SECTION */}
          {isSectionAllowed("property_team") && (
            <AccordionMenu
              icon={property}
              title="Properties"
              items={propertyMenu.filter((i) => canAccessPage(i.name))}
              setSidebarOpen={setSidebarOpen}
            />
          )}

          {/* LOANS SECTION */}
          {isSectionAllowed("loan_team") && (
            <AccordionMenu
              icon={bank}
              title="Loans"
              items={loanMenu.filter((i) => canAccessPage(i.name))}
              setSidebarOpen={setSidebarOpen}
            />
          )}

          {/* SERVICES SECTION */}
          {isSectionAllowed("services_team") && (
            <AccordionMenu
              icon={HomeService}
              title="Services"
              items={servicesMenu.filter((i) => canAccessPage(i.name))}
              setSidebarOpen={setSidebarOpen}
            />
          )}

          {/* ADMIN ONLY MENUS */}
          {(isAdmin || isTeamLeader) && (
            <>
              <MenuItem
                to="/vacancies"
                icon={FiBriefcase}
                label="Career Management"
                setSidebarOpen={setSidebarOpen}
              />

              <MenuItem
                to="/admins"
                icon={FiUserCheck}
                label="Admin Management"
                setSidebarOpen={setSidebarOpen}
              />

              <MenuItem
                to="/associated-clients"
                icon={FaHandshake}
                label="Associated Clients"
                setSidebarOpen={setSidebarOpen}
              />

              <MenuItem
                to="/services/payment-history"
                icon={FiCreditCard}
                label="Payment History"
                setSidebarOpen={setSidebarOpen}
              />

              <MenuItem
                to="/banners"
                icon={FiImage}
                label="Add Banners"
                setSidebarOpen={setSidebarOpen}
              />


{/* USERS MANAGEMENT */}
              <MenuItem
                to="/users"
                icon={FiUsers}
                label="Users Management"
                setSidebarOpen={setSidebarOpen}
              />
              <MenuItem
                to="/cities"
                icon={FiMapPin}
                label="City Management"
                setSidebarOpen={setSidebarOpen}
              />

 
            </>
          )}



          {isSectionAllowed("support_team") && (
            <MenuItem
              to="/contact-us"
              img={contact}
              label="Contact Us"
              setSidebarOpen={setSidebarOpen}
            />
          )}

          <SectionTitle title="System Settings" />
          <MenuItem
            to="/settings/profile"
            img={profile}
            label="Profile Settings"
            setSidebarOpen={setSidebarOpen}
          />
          <MenuItem
            to="/settings/security"
            img={security}
            label="Security Settings"
            setSidebarOpen={setSidebarOpen}
          />
        </div>

        {/* LOGOUT FIXED BOTTOM */}
        <div className="border-t border-gray-200 dark:border-white/10 p-4">
          <button
            onClick={() => setShowLogoutPopup(true)}
            className="flex items-center gap-3 px-4 py-3 w-full rounded-lg 
            text-red-600 hover:bg-red-500 hover:text-white
            dark:text-red-400 dark:hover:bg-red-500/10 transition"
          >
            <img
              src={logout}
              alt="logout icon"
              className="w-5 h-5 object-contain"
            />
            <span className="font-medium text-white">Logout</span>
          </button>
        </div>
      </div>

      {/* LOGOUT POPUP */}
      {showLogoutPopup && (
        <div className="fixed inset-0 bg-black/60 z-[999] flex justify-center items-center">
          <div className="bg-[#0B1324] text-center p-8 rounded-2xl w-[90%] sm:w-[420px] shadow-xl">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Logout Confirmation
            </h2>

            <p className="text-gray-300 text-sm mb-6 leading-relaxed">
              Are you sure you want to log out?
              <br />
              You will be signed out from the Super Admin panel.
            </p>

            <div className="flex justify-center gap-4">
              <button
                onClick={() => setShowLogoutPopup(false)}
                className="bg-white text-black px-6 py-3 rounded-lg w-32 font-medium hover:bg-gray-200 transition"
              >
                Cancel
              </button>

              <button
                onClick={() => onErrorLogout()}
                className="bg-red-600 text-white px-6 py-3 rounded-lg w-32 font-medium hover:bg-red-700 transition"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/* ===== COMPONENTS ===== */

function SectionTitle({ title }) {
  return (
    <p className="text-xs uppercase tracking-wide text-white dark:text-gray-400 px-6 mt-4 mb-1">
      {title}
    </p>
  );
}

function MenuItem({ to, img, icon: Icon, label, setSidebarOpen }) {
  const base =
    "flex items-center gap-2 px-6 py-2 w-full cursor-pointer transition-all leading-none";

  const inactive =
    "text-white hover:bg-gradient-to-r hover:from-[#24ADD7] hover:to-[#186cbc] hover:text-white " +
    "dark:text-gray-300 dark:hover:bg-gradient-to-r dark:hover:from-[#D9D9D9] dark:hover:to-[#071226] dark:hover:text-white my-1";

  const active =
    "text-white font-medium shadow-md bg-gradient-to-r from-[#24ADD7] to-[#186cbc] " +
    "dark:bg-gradient-to-r dark:from-[#D9D9D9] dark:to-[#071226] my-1";

  return (
    <NavLink
      to={to}
      end
      onClick={() => {
        if (window.innerWidth < 1024) setSidebarOpen(false);
      }}
      className={({ isActive }) => `${base} ${isActive ? active : inactive}`}
    >
      {Icon ? (
        <Icon className="w-5 h-5 text-white" />
      ) : (
        <img src={img} alt={label} className="w-5 h-5 object-contain" />
      )}
      <span className="text-[14px]">{label}</span>
    </NavLink>
  );
}


function SubMenuItem({ to, label, setSidebarOpen }) {
  const inactive =
    "text-white hover:bg-gradient-to-r hover:from-[#24ADD7] hover:to-[#186cbc] hover:text-white " +
    "dark:text-gray-300 dark:hover:bg-gradient-to-r dark:hover:from-[#D9D9D9] dark:hover:to-[#071226] dark:hover:text-white my-1";

  const active =
    "text-white font-medium shadow-md bg-gradient-to-r from-[#24ADD7] to-[#186cbc] " +
    "dark:bg-gradient-to-r dark:from-[#D9D9D9] dark:to-[#071226] my-1";

  return (
    <NavLink
      to={to}
      end
      onClick={() => {
        if (window.innerWidth < 1024) setSidebarOpen(false);
      }}
      className={({ isActive }) =>
        `block px-6 py-1.5 text-[13px] my-1 rounded-md transition-all 
        ${isActive ? active : inactive}`
      }
    >
      {label}
    </NavLink>
  );
}

// FIX APPLIED HERE: Hook order corrected
function AccordionMenu({ icon, title, items, setSidebarOpen }) {
  const location = useLocation();

  // 1. Calculate active state (safe to do here before useState)
  const isActiveSection =
    items && items.length > 0
      ? items.some((item) => location.pathname.startsWith(item.to))
      : false;

  // 2. Call Hooks (useState) ALWAYS before any return statement
  const [open, setOpen] = useState(isActiveSection);

  // 3. NOW check for empty items and return null if needed
  if (!items || items.length === 0) return null;

  return (
    <div className="my-1">
      <div
        onClick={() => setOpen(!open)}
        className="flex items-center px-6 py-2 cursor-pointer gap-2 rounded-md hover:bg-black/10 dark:hover:bg-white/5"
      >
        <img src={icon} alt={title} className="w-5 h-5 object-contain" />
        <span className="font-medium text-[14px]">{title}</span>
        <span className="ml-auto text-white">{open ? "▾" : "▸"}</span>
      </div>

      {open && (
        <div className="mt-1 ml-4 border-l border-white/20">
          {items.map((item) => (
            <SubMenuItem
              key={item.to}
              to={item.to}
              label={item.label}
              setSidebarOpen={setSidebarOpen}
            />
          ))}
        </div>
      )}
    </div>
  );
}
